export const AccountStatus = {
  Active: 'Active',
  Blocked: 'Blocked',
  Closed: 'Closed',
  Dormant: 'Dormant',
  Delinquent: 'Delinquent',
} as const;
export type AccountStatus = (typeof AccountStatus)[keyof typeof AccountStatus];
